<template>
  <div id="resource-content">
    <div class="filter">
      <el-input type="text" v-model="query" placeholder="搜索">
        <i class="el-icon-search el-input__icon" slot="suffix"> </i>
      </el-input>
      <multi-selecter :options="typeTags" :value.sync="category" label="行业分类"/>
    </div>
    <div class="list">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="name">{{ item.name }}</div>
        <div
          class="content"
          v-html="item.filePath"
          @click="loadTemplate(item)"
        ></div>
      </div>
      <div
        class="more"
        v-waypoint="{ active: !loading && !end, callback: onWaypoint }"
        v-if="!end"
      >
        <span v-if="loading">加载中</span>
        <!--<span v-if="!loading&&end">没有更多了</span>-->
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelecter from 'components/MultiSelecter';
import _ from 'lodash';

export default {
  components: {
    'multi-selecter': MultiSelecter,
  },
  data() {
    return {
      loading: false,
      query: '',
      category: null
    };
  },
  methods: {
    refreshData() {
      this.handleChangePage(1);
    },
    fetchData() {
      this.$store.dispatch('basic/fetch', {});
    },
    handleChangePage(page) {
      this.$store.commit('basic/update', {
        page
      });
      this.fetchData();
    },
    loadTemplate(data) {
      this.$confirm('是否要加载模板', {
        customClass: 'confirm',
        type: 'warning'
      }).then(() => {
        this.$store.commit('load_template', data);
      });
    },
    fetchNextPage() {
      if (!this.end && this.list.length) {
        this.$store.commit('basic/update', {
          page: this.$store.state.basic.page + 1
        });
        this.loading = true;
        this.$store.dispatch('basic/fetchMore').then(() => {
          this.loading = false;
        });
      }
    },
    onWaypoint({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN && direction === 'top') {
        this.fetchNextPage();
      }
    }
  },
  beforeDestroy() {
    this.$store.commit('basic/update', {
      condition: {}
    });
  },
  watch: {
    query() {
      this.$store.commit('basic/update', {
        condition: {
          name: this.query || undefined
        }
      });
      this.refreshData();
    },
    category(value) {
      this.$store.commit('basic/update', {
        condition: {
          tagIds: _.join(_.map(value||[], 'id'), ',') ,
          name: this.query
        }
      });
      this.refreshData();
    }
  },
  computed: {
    end() {
      return (
        this.$store.state.basic.list.length >= this.$store.state.basic.total
      );
    },
    list() {
      return this.$store.state.basic.list || [];
    },
    tags() {
      return this.$store.state.tags.list || [];
    },
    typeTags() {
      return _.filter(this.$store.state.tags.list, function(o) {
        return o.type === 0 && o.name !== '其他';
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#resource-content {
  display: flex;
  flex-direction: column;
  width: 256px;
  height: calc(100vh - 60px);
  border-right: 1px solid #cfd3dd;
}

.item {
  overflow: hidden;
}

.filter {
  position: relative;
  display: flex;
}

.filter {
  :global(input) {
    border: 0;
    flex: none;
    box-sizing: border-box;
    padding: 10px 12px;

    &::placeholder {
      color: #75808b;
      font-size: 14px;
    }
  }
  :global(.el-icon-search) {
    font-size: 20px;
    margin-right: 8px;
  }
  :global(.el-select) {
    border-left: 1px solid #cfd3dd;
  }
}

.filter :global(.el-input) {
  width: 100%;
  border-bottom: 1px solid #cfd3dd;
  box-sizing: border-box;
}

.list {
  width: 256px;
  padding: 25px 28px 0;
  flex: auto;
  overflow: auto;
  .item {
    cursor: pointer;
    margin-bottom: 20px;
  }
  .item .content {
    min-height: 10px;
    border: 1px solid #e9edf0;
    > :global(svg) {
      width: 100%;
      height: auto;
    }
  }
  .item .name {
    text-align: left;
    padding-bottom: 5px;
    color: #000;
    font-size: 14px;
    line-height: 20px;
  }
  .more {
    height: 20px;
    width: 100%;
    opacity: 0;
  }
}
</style>